<template>
  <init-loader v-if="skeletonLoading"></init-loader>
  <v-card flat v-else>
    <v-card-text>

      <v-alert
        v-if="!items.length"
        prominent
        type="success"
      >
        <v-row align="center">
          <v-col class="grow">생선된 페이지가 없습니다.</v-col>
        </v-row>
      </v-alert>
      <v-row v-else>
        <template v-for="(item, i) in items">
          <v-col cols="12" sm="6" md="4" lg="3" :key="i">
            <v-card height="100%">
              <v-toolbar color="transparent" flat dense>
                <v-toolbar-title>
                  <v-chip color="secondary" class="mr-2" small link :to="`/${category}/index?category=${item.category}`">
                    <span class="text-uppercase font-weight-bold">{{item.category}}</span>
                  </v-chip>
                  {{item.title}}
                </v-toolbar-title>
                <v-spacer/>
                <v-btn color="success" icon :to="`/${category}/${item.id}`"><v-icon>mdi-arrow-right-circle</v-icon></v-btn>
              </v-toolbar>
              <v-list-item three-line>
                <v-list-item-avatar>
                  <v-img :src="item.thumbnail"></v-img>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-subtitle v-text="item.subtitle"></v-list-item-subtitle>
                  <v-list-item-subtitle class="text-right font-italic">작성일: &nbsp;<display-time :time="item.createdAt" /></v-list-item-subtitle>
                  <v-list-item-subtitle class="text-right font-italic">게시물: {{item.count}}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-card-text style="white-space: pre-line">{{item.description}}</v-card-text>
            </v-card>
          </v-col>
        </template>
        <v-col cols="12" sm="6" md="4" lg="3">
          <v-card height="100%" class="d-flex" color="transparent" flat>
            <v-row justify="center" align="center">
              <v-btn @click="subscribe" v-intersect="onIntersect" color="success" text ref="btnMore"><v-icon large left>mdi-chevron-double-right</v-icon>더보기</v-btn>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script>
import InitLoader from './components/index-skeleton'
import DisplayTime from '@/components/display-time'
import pluralize from 'pluralize'
import delay from 'delay'
// import { last } from 'lodash'

export default {
  components: { InitLoader, DisplayTime },
  props: ['category'],
  data () {
    return {
      unsubscribe: null,
      ref: null,
      collection: pluralize(this.category),
      items: [],
      skeletonLoading: false,
      limit: 4,
      // last: null,
      loading: false
    }
  },
  watch: {
    '$store.state.loaded' (n, o) {
      this.initLoad().then(() => this.subscribe())
    },
    '$route.query' (n, o) {
      this.initLoad().then(() => this.subscribe())
    }
  },
  mounted () {
    this.initLoad().then(() => this.subscribe())
  },
  destroyed () {
    if (this.unsubscribe) this.unsubscribe()
  },
  methods: {
    onError (e) {
      this.skeletonLoading = false
      this.$toast.error(e.message)
    },
    toPath (item) {
      const s = this.$route.path.split('/')
      s[s.length - 1] = item.id
      return s.join('/')
    },
    async initLoad () {
      this.skeletonLoading = true
      await delay(500)
      this.skeletonLoading = false
    },
    subscribe () {
      if (this.loading) return
      this.loading = true
      const category = this.$route.query.category
      this.ref = category
        ? this.$firebase.firestore().collection(this.collection).where('category', '==', category)
        : this.$firebase.firestore().collection(this.collection)

      const ref = this.ref.orderBy('createdAt').limit(this.limit)
      this.unsubscribe = ref.onSnapshot((sn) => {
        this.loading = false
        if (sn.empty) return
        // this.last = last(sn.docs)
        const items = sn.docs.map(doc => {
          const item = doc.data()
          item.id = doc.id
          item.createdAt = item.createdAt.toDate()
          item.updatedAt = item.updatedAt.toDate()
          return item
        })
        this.items = items // this.items.concat(items)
        if (this.limit > 100) return
        if (this.items.length === this.limit) this.limit += 4
      }, this.onError)
    },
    onIntersect (entries, observer, isIntersecting) {
      if (isIntersecting) this.subscribe()
    }
  }
}
</script>
